import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-02-22'
        tag='Kidizen'
        title='The Lowdown on Kidizen Seller Protection and Return Policy'
      >
        <p>
          One of the first things sellers need to find out before making their first sale is how a platform would
          support them in unfortunate cases. This includes when shipments get lost in transit or when a buyer makes a
          false accusation about an item arriving “not as described” or a counterfeit. These are common challenges
          across all reselling marketplaces, but policies may vary, so you would want to check before getting started.
        </p>

        <h3>How does Kidizen protect its sellers?</h3>
        <p>
          On Kidizen, Seller Protection is clearly stated on their website. There are three ways they show support to
          sellers, and each one covers the aforementioned instances.
        </p>
        <p>
          First is through Shipping Label Insurance, wherein Kidizen shoulders the refund to the buyer when the shipment
          gets lost. This is only applicable if the two conditions are met: (1) The seller purchased the shipping label
          through Kidizen; (2) There is proof that the item was indeed dispatched by the seller and scanned by the
          shipping partner but did not reach its recipient.
        </p>
        <p>
          Otherwise, the seller is expected to refund the buyer if the shipping label was bought elsewhere. If there is
          proof that the shipment reached its destination, the buyer will be held responsible instead.
        </p>
        <p>
          The second is through Dispute Mediation. If a buyer claims that the item received doesn’t match the
          description or photos on the listing, sellers are encouraged first to try to settle it by themselves. However,
          if there’s no resolution after a given period, Kidizen may be called to step in and mediate the dispute.
        </p>
        <p>
          The third is through Fraud Protection. Kidizen protects the sellers by keeping tabs on buyers with a history
          of such claims regarding accusations over the authenticity of the items sold.
        </p>

        <h3>What is Kidizen’s Return Policy?</h3>
        <p>
          Returns may be inevitable, but there are ways to prevent them from happening. It all boils down to both
          parties exercising their respective responsibilities. Sellers are expected to be as clear and honest about the
          items they’re listing, and buyers must be discerning if a listing seems vague or suspicious. If there is
          additional information a buyer needs to know (e.g., sizing and measurements), they must reach out before
          purchase instead of making assumptions. This way, everyone is on the same page.
        </p>
        <p>
          If a buyer would like to cancel a paid order but not yet shipped, the decision to approve the cancellation
          relies on the seller. If the item was already shipped out and the buyer wants to have their money back,
          Kidizen considers refunds only under these specific instances:
        </p>
        <ol>
          <li>
            <p>
              <strong>The buyer did not receive the order.</strong> There are instances when the buyer aren’t able to
              get the order at all – either the seller failed to ship it, or the shipment got lost in transit and failed
              to reach its destination.
            </p>
            <p>
              <em>Conditions and considerations:</em>
            </p>
            <ul>
              <li>
                The buyer must open a refund claim within 90 days since the order was purchased. The earliest a buyer
                could file for a refund is on Day 8 or a week after the seller was supposed to ship the item.
              </li>
              <li>
                Kidizen will cover the refund to the buyer if the seller bought the shipping label through the platform
                and the shipping partner failed to deliver the item. If the seller used another courier, the seller
                would refund the buyer.
              </li>
              <li>
                No refund will be issued to the buyer if tracking information proves the shipment received its
                destination.
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>The order received was wrong or not as described.</strong> Kidizen recommends that the buyer reach
              out directly to the seller using the platform’s messaging system as soon as the order is received or
              within five days of delivery. The seller is expected to work out a solution within a few days. Otherwise,
              the buyer can already lodge a refund claim.
            </p>
            <p>
              <em>Conditions and considerations:</em>
            </p>
            <ul>
              <li>
                For a refund claim to be successful, the item must not show any signs of alteration and signs that the
                item was worn, laundered, or stain-treated.
              </li>
              <li>
                Complaints regarding the odor of the item will only be considered if there were previous similar
                complaints against the seller.
              </li>
              <li>
                If Kidizen approves the refund claim, the seller has the option to get back the item. In this case, the
                seller shoulders the return shipping, but it is the buyer’s responsibility to make sure the item is
                shipped back within 5 to 30 days in the original condition they received it. Otherwise, Kidizen will
                forfeit the refund claim.
              </li>
              <li>
                In cases wherein the buyer received the item exactly as described but would like to file for a refund
                because they don’t want the item anymore (or it doesn’t fit, but the sizing on the listing was
                accurate), this may be coursed directly to the seller and will depend solely on the seller’s decision.
              </li>
            </ul>
          </li>
        </ol>

        <h3>What will happen to seller funds after a dispute?</h3>
        <p>
          Once Kidizen has done its investigation and finds that the seller is at fault, the refund to the buyer will be
          deducted from the seller’s Kid Bucks. If the amount on the platform’s account balance is insufficient, the
          amount will then be taken from the linked payment method of the seller.
        </p>
        <p>
          If a buyer fails to return an item to the seller after 30 days, or if they sent it back in an altered or
          unacceptable condition, the refund might be forfeited, and the amount will be credited back to the seller.
        </p>
        <p>
          There may be rare instances not covered in this article, and when that happens, it’s always best to reach out
          directly to Kidizen for assistance. Just remember the basics that will always help you win your case: honest,
          transparent listing and responsiveness to both your buyers and to Kidizen. Time is just as important as facts
          in handling these issues.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
